import {Button, Checkbox, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from '@mui/material';
import {Dispatch, SetStateAction} from 'react';

export interface CheckboxTableProps {
  items: string[];
  selectedItems: string[];
  setSelectedItems: Dispatch<SetStateAction<string[]>>;
}

export default function CheckboxTable({items, selectedItems, setSelectedItems}: CheckboxTableProps) {
  const handleChange = (item: string, currentlyChecked: boolean) => {
    setSelectedItems((prev) => {
      if (currentlyChecked) {
        // remove if already exists
        return prev.filter((i) => i !== item);
      }
      return [...prev, item];
    });
  };

  return (
    <TableContainer component={Paper} sx={{maxHeight: '60vh', overflowY: 'scroll'}}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>
              <Button component="button" onClick={() => setSelectedItems(items)}>
                Select All
              </Button>{' '}
              /{' '}
              <Button component="button" onClick={() => setSelectedItems([])}>
                Clear
              </Button>
            </TableCell>
            <TableCell>Item folder</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map((item) => {
            const checked = !!selectedItems.includes(item);
            return (
              <TableRow key={item}>
                <TableCell>
                  <Checkbox checked={checked} onChange={() => handleChange(item, checked)} />
                </TableCell>
                <TableCell>{item}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
